export const ABORT_REQUEST_PATHS = [
    'patient/documents',
];
